import { jsx } from "react/jsx-runtime";
import { ThemeableStack } from "@tamagui/stacks";
import {
  isTamaguiElement,
  styled,
  withStaticProperties
} from "@tamagui/web";
import React, { cloneElement, forwardRef } from "react";
const CardFrame = styled(ThemeableStack, {
  name: "Card",
  backgroundColor: "$background",
  position: "relative",
  overflow: "hidden",
  variants: {
    size: {
      "...size": (val, { tokens }) => {
        return {
          borderRadius: tokens.radius[val] ?? val
        };
      }
    }
  },
  defaultVariants: {
    size: "$true"
  }
});
const CardHeader = styled(ThemeableStack, {
  name: "CardHeader",
  zIndex: 10,
  backgroundColor: "transparent",
  marginBottom: "auto",
  variants: {
    size: {
      "...size": (val, { tokens }) => {
        return {
          padding: tokens.space[val] ?? val
        };
      }
    }
  }
});
const CardFooter = styled(CardHeader, {
  name: "CardFooter",
  zIndex: 5,
  flexDirection: "row",
  marginTop: "auto",
  marginBottom: 0
});
const CardBackground = styled(ThemeableStack, {
  name: "CardBackground",
  zIndex: 0,
  fullscreen: true,
  overflow: "hidden",
  pointerEvents: "none",
  padding: 0
});
const Card = withStaticProperties(
  CardFrame.extractable(
    forwardRef(
      ({ size, __scopeCard, children, ...props }, ref) => {
        return (
          // <CardProvider scope={__scopeCard} size={size}>
          /* @__PURE__ */ jsx(CardFrame, { ref, ...props, children: React.Children.map(children, (child) => {
            if (isTamaguiElement(child) && !child.props.size) {
              return cloneElement(child, {
                size
              });
            }
            return child;
          }) })
        );
      }
    )
  ),
  {
    Header: CardHeader,
    Footer: CardFooter,
    Background: CardBackground
  }
);
export {
  Card,
  CardBackground,
  CardFooter,
  CardFrame,
  CardHeader
};
//# sourceMappingURL=Card.js.map
